import { GET_FORM_LABEL, GET_FORM_LABEL_BY_FORM } from '../types'

const initialState = {
  formLabel: [],
  formLabeByForm: [],

  loading: true
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_FORM_LABEL:
      return {
        ...state,
        formLabel: action.payload,
        loading: false
      }
    case GET_FORM_LABEL_BY_FORM:
      return {
        ...state,
        formLabeByForm: action.payload,
        loading: false
      }
    default:
      return state
  }
}
